import React, { useEffect, useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

import { useUnidades } from "../../../hooks/test/useUnidades";
import Swal from "sweetalert2";
import { SocketContext } from "../../../context/SocketContext";
import { verifyJWT2 } from "../../../helpers/JWT";
import { AuthContext } from "../../../context/authContext/authContext";

export const FormularioBitacoraGeneral = ({
  viaje_id,
  negocioId,
  getBitacora = () => {},
  close = null,
}) => {
  const { getListaEstatus, postBitacora } = useUnidades();
  const [listaEstatus, setListaEstatus] = useState([]);
  const [loading, setLoading] = useState(false);
  const { socket } = useContext(SocketContext);
  const [form, setForm] = useState({
    status_id: "",
    descripcion: "",
  });
  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };
  const saveForm = async (event) => {
    event.preventDefault();

    let resp = await postBitacora({
      id_viaje: viaje_id,
      notas: form.descripcion,
      id_status: form.status_id,
    });

    if (resp.ok)
      Swal.fire({
        title: "Bitacora actualizada con éxito",
        text: resp.msg ? resp.msg : "Se agrego a bitacora",
        icon: "success",
      });

    if (!resp.ok)
      return Swal.fire({
        title: "No se pudo guardar la bitacora",
        text: resp.msg ? resp.msg : "",
        icon: "error",
      });

    getBitacora();
    
    socket.emit("traer-unidades-en-ruta_", { idNegocio: negocioId});

    clearForm();
  };

  useEffect(() => {
    setLoading(true);
    getEstatus();
    setLoading(false);
  }, []);
  const getEstatus = async () => {
    let resp = await getListaEstatus();
    if (resp.ok) setListaEstatus(resp.estatus);
  };

  const clearForm = () => {
    setForm({ status_id: "", hora: "", descripcion: "" });
  };
  const { status_id, descripcion } = form;
  return (
    <>
      <form className="form-group" onSubmit={saveForm}>
        <div className="row">
          <select
            className="form-control control-input selectCedis"
            value={status_id}
            name="status_id"
            onChange={handleChange}
            required
          >
            <option value="">SELECCIONA ESTATUS</option>
            {listaEstatus.map((elemento) => (
              <option value={`${elemento.status_id}`} key={elemento.status_id} disabled={elemento.cancel === 1} >
                {elemento.nombre}
              </option>
            ))}
          </select>
        </div>
        <br />
        <div className="row">
          <textarea
            className="form-control"
            placeholder="Observaciones o comentarios"
            value={descripcion}
            name="descripcion"
            onChange={handleChange}
            style={{ fontSize: "18px" }}
          ></textarea>
        </div>
        <br />
        <button className="btn btn-warning btn-block" disabled={loading}>
          <FontAwesomeIcon icon={faPaperPlane} /> Enviar evento
        </button>
      </form>
    </>
  );
};
